import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface User {
  id?: number;
  username: string;
  first_name: string;
  is_supper_user: string;
  last_name: string;
  permissions: string[];
}

interface AuthState {
  user: User | null;
  access_token: string | null;
  refresh_token: string | null;
  is_2fa_enabled: boolean;
  twoFaUsername: string | null;
}

const initialState: AuthState = {
  user: null,
  access_token: null,
  refresh_token: null,
  is_2fa_enabled: false,
  twoFaUsername: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login: (
      state,
      action: PayloadAction<{
        user: User;
        access_token: string;
        refresh_token: string;
        is_2fa_enabled: boolean;
        twoFaUsername?: string;
      }>
    ) => {
      state.user = action.payload.user;
      state.access_token = action.payload.access_token;
      state.refresh_token = action.payload.refresh_token;
      state.is_2fa_enabled = action.payload.is_2fa_enabled;
      if (action.payload.twoFaUsername) {
        state.twoFaUsername = action.payload.twoFaUsername;
      }
    },
    setTwoFaUsername: (state, action: PayloadAction<string>) => {
      state.twoFaUsername = action.payload;
    },
    clearTwoFaUsername: (state) => {
      state.twoFaUsername = null;
    },
    logout: (state) => {
      state.user = null;
      state.access_token = null;
      state.refresh_token = null;
      state.is_2fa_enabled = false;
      state.twoFaUsername = null;
    },
  },
});

export const { login, setTwoFaUsername, clearTwoFaUsername, logout } =
  authSlice.actions;
export default authSlice.reducer;
